import Header from "@/components/Header";
import Sidebar from "@/components/Sidebar";
import { verifikatorNavigations } from "@/constants";
import { useUser } from "@/hooks/useUser";
import { Navigate, Outlet } from "react-router-dom";

export default function VerifikatorLayout() {
  const { user, isPending } = useUser();
  const userRoles = user?.jenis_user || [];
  const isVerifikatorAll = userRoles.includes("verifikator_ukt_all");
  const verifikator = userRoles.includes("verifikator_ukt") || isVerifikatorAll;

  // const navigationMenus = isVerifikatorAll
  //   ? verifikatorNavigations.map((nav) =>
  //       nav.title === "MAIN"
  //         ? {
  //             ...nav,
  //             menus: [
  //               ...nav.menus,
  //               {
  //                 name: "Rekap Verifikasi",
  //                 path: "/verifikator/rekap-verifikasi",
  //                 icon: <MdDataUsage />,
  //               },
  //             ],
  //           }
  //         : nav,
  //     )
  //   : verifikatorNavigations;

  if (!isPending && !verifikator) return <Navigate to={"/"} />;

  return (
    <main className="flex">
      <Sidebar navigationMenus={verifikatorNavigations} />

      <section className="flex-1 min-w-0 p-5 min-h-screen">
        <div className="relative">
          <Header />
          <Outlet />
        </div>
      </section>
    </main>
  );
}
